// @ts-nocheck
import React from 'react';
import { Modal as ReactModal } from 'react-overlays';
import ModalTransition from './modal-transition';
import Tooltip from './tooltip';

const EmptyTransition = (props: any) => props.children;

const modalStyle: Styles = {
  position: 'fixed',
  zIndex: 1000,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
};

const backdropStyle: Styles = {
  position: 'fixed',
  zIndex: 'auto',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: 'rgba(38, 50, 56, 0.8)',
};

interface Props {
  show: boolean;
  children: React.ReactNode;
  transition?: () => void;
  dialogTransitionTimeout?: number;
  backdropTransitionTimeout?: number;
  backgroundColor?: string;
  onHide?: () => void;
  onHidden?: () => void;
  customModalStyles?: Styles;
}

export default class Modal extends React.Component<Props, {}> {
  static defaultProps = {
    // use a no-op for the transition because we want to render our own transition
    dialogTransitionTimeout: 300,
    backdropTransitionTimeout: 300,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  };

  _modal: ReactModal;

  render() {
    const {
      children,
      dialogTransitionTimeout,
      backdropTransitionTimeout,
      backgroundColor,
      transition,
      onHide,
      onHidden,
      customModalStyles,
      ...props
    } = this.props;

    const CustomTransition = transition || ModalTransition;
    const modalStyles = customModalStyles ? { ...modalStyle, ...customModalStyles } : modalStyle;

    const renderBackdrop = () => {
      const backdropProps = {
        onClick: onHide,
      };

      return (
        <CustomTransition
          transitionAppear
          in={this.props.show}
          timeout={backdropTransitionTimeout}
        >
          <div className="components-modal-backdrop" style={{ ...backdropStyle, backgroundColor }} {...backdropProps} />
        </CustomTransition>
      );
    };

    const renderDialog = (props) => (
      <div {...props}>
        {renderBackdrop()}
        <CustomTransition
          transitionAppear
          unmountOnExit
          in={this.props.show}
          timeout={dialogTransitionTimeout}
          onExited={this.handleHidden}
        >
          {children}
        </CustomTransition>
        <Tooltip />
      </div>
    );

    return (
      // @ts-ignore the style prop is not typed
      <ReactModal
        enforceFocus={false}
        style={modalStyles}
        renderDialog={renderDialog}
        transition={EmptyTransition}
        className="bootstrap-react-modal"
        ref={this.bindModal}
        {...props}
      />
    );
  }

  handleHidden = () => {
    if (this._modal) {
      // @ts-ignore this is not in the current type definitions
      this._modal.handleHidden();
    }

    if (this.props.onHidden) {
      this.props.onHidden();
    }
  };

  bindModal = (node) => {
    this._modal = node;

    if (node) {
      Tooltip.rebuild();
    }
  };
}
